import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=61a205f6&scoped=true"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusModal.vue?vue&type=style&index=0&id=61a205f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a205f6",
  null
  
)

export default component.exports